<template>
  <div>
    <md-field>
      <label>工具类型</label>
      <md-select v-model="form.tool_type" name="tooltype" id="tooltype">
        <md-option value="xzjg">旋转紧固类</md-option>
        <md-option value="fzqj">辅助敲击类</md-option>
        <md-option value="zkqx">钻孔切削类</md-option>
        <md-option value="ybcl">仪表测量类</md-option>
        <md-option value="dmpg">打磨抛光类</md-option>
        <md-option value="hjnt">焊接粘接类</md-option>
        <md-option value="jyl">绝缘类</md-option>
        <md-option value="zygj">专用工具</md-option>
      </md-select>
    </md-field>
    <md-field>
      <label>工具元件</label>
      <md-select v-model="form._id" name="_id" id="_id">
        <md-option v-for="item in list" :key="item._id" :value="item._id">{{ item.name }}</md-option>
      </md-select>
    </md-field>

    <md-field>
      <label>动作列表</label>
      <md-select v-model="form.template_id" name="_id">
        <md-option :value="item.id" v-for="item in actionMap[form._id]" :key="item.id">{{ item.name }}</md-option>
      </md-select>
    </md-field>

    <md-field v-if="template === 'move'">
      <label>移动模式 *</label>
      <md-select v-model="form.moveModel" name="move_mod" :disabled="disabled">
        <md-option value="sy">瞬移</md-option>
        <md-option value="py">平移</md-option>
        <md-option value="xj">寻径</md-option>
      </md-select>
    </md-field>

    <div class="md-layout" v-if="template === 'move'">
      <div class="md-layout-item md-size-15" style="padding-left: 0px; padding-top: 20px">
        <label class="md-layout-item md-size-15 md-form-label">移动坐标 *</label>
      </div>
      <div class="md-layout-item md-size-30">
        <md-field>
          <label>X</label>
          <md-input v-model="form.movezbx" type="text" :disabled="disabled"></md-input>
        </md-field>
      </div>

      <div class="md-layout-item md-size-30">
        <md-field>
          <label>Y</label>
          <md-input v-model="form.movezby" type="text" :disabled="disabled"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-25">
        <md-field>
          <label>Z</label>
          <md-input v-model="form.movezbz" type="text" :disabled="disabled"></md-input>
        </md-field>
      </div>
    </div>

    <md-field v-if="template === 'move'">
      <label>移动时间(秒) *</label>
      <md-input v-model="form.moveTime" type="text" :disabled="disabled"> </md-input>
    </md-field>

    <div class="md-layout" v-if="template === 'rotate'">
      <div class="md-layout-item md-size-15" style="padding-left: 0px; padding-top: 20px">
        <label class="md-form-label-ext"> 旋转坐标 * </label>
      </div>
      <div class="md-layout-item md-size-30">
        <md-field>
          <label>X</label>
          <md-input v-model="form.rotatex" type="text" :disabled="disabled"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-30">
        <md-field>
          <label>Y</label>
          <md-input v-model="form.rotatey" type="text" :disabled="disabled"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-25">
        <md-field>
          <label>Z</label>
          <md-input v-model="form.rotatez" type="text" :disabled="disabled"></md-input>
        </md-field>
      </div>
    </div>

    <md-field v-if="template === 'rotate'">
      <label>旋转时间(秒) *</label>
      <md-input v-model="form.rotateTime" type="text" :disabled="disabled"> </md-input>
    </md-field>

    <md-field v-if="template === 'animation'">
      <label>动画资源 *</label>
      <md-input v-model="form.animateResource" type="text" :disabled="disabled"></md-input>
    </md-field>

    <md-field v-if="template === 'animation'">
      <label>播放速率(帧/秒) *</label>
      <md-input v-model="form.animateSpeed" type="text" :disabled="disabled"> </md-input>
    </md-field>

    <md-field v-if="template === 'animation'">
      <div class="md-layout">
        <div class="md-layout-item md-size-20">
          <label style="padding-top: 5px">是否倒播</label>
        </div>
        <div class="md-layout-item md-size-75">
          <md-switch v-model="form.replay" :disabled="disabled"></md-switch>
        </div>
      </div>
    </md-field>
  </div>
</template>

<script>
import { listUtilComponent } from '@/api/component/util_component'
import { copyProperty } from '@/utils/util'
export default {
  data() {
    return {
      form: {},
      pagination: {
        perPage: 1000,
        currentPage: 1
      },
      list: [],
      actionMap: {},
      disabled: false
    }
  },
  computed: {
    template() {
      const temp_id = this.form.template_id
      if (temp_id) {
        const act = this.actionMap[this.form._id].find((item) => item.id === temp_id)
        copyProperty(['moveModel', 'movezbx', 'movezby', 'movezbz', 'moveTime', 'rotatex', 'rotatey', 'rotatez', 'rotateTime', 'animateResource', 'animateSpeed', 'replay'], this.form, act)
        this.disabled = act.type === 'static'
        return act.template
      }
      return ''
    }
  },
  watch: {
    'form.tool_type'() {
      this.getList()
    }
  },
  methods: {
    getList() {
      let query = Object.assign({}, this.pagination)
      if (this.form.tool_type) {
        query.tool_type = this.form.tool_type
      }
      listUtilComponent(query).then((res) => {
        this.list = res.data.rows
        this.actionMap = res.data.rows.reduce((pre, next) => {
          pre[next._id] = next.action_list
          return pre
        }, {})
      })
    }
  }
}
</script>

<style></style>
